import { useEffect, useRef } from 'react'

import clsx from 'clsx'

import '@hotmart/cosmos/dist/dropdown'
import Icon from '../../icon'

import type { CustomDropdownItemProps, CustomDropdownProps } from '../types'

const CustomDropdown = ({
  icon,
  label,
  children,
  className,
  disabled = false,
  side = 'left'
}: CustomDropdownProps) => {
  const dropdownRef = useRef<HTMLDivElement>(null)
  const itemRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    if (dropdownRef.current) {
      const shadowRootDropdown = dropdownRef.current.shadowRoot
      const dropdownElement = shadowRootDropdown?.querySelector(
        '.hot-dropdown__menu'
      ) as HTMLDivElement
      dropdownElement.style.margin = '0'
      dropdownElement.style.minWidth = '19.5rem'
      dropdownElement.style.width = 'fit-content'
    }
  }, [dropdownRef])

  return (
    <hot-dropdown ref={dropdownRef} menu-side={side} class={clsx(className, `hot-drop${side}`)}>
      <button
        ref={itemRef}
        disabled={disabled}
        slot='button'
        aria-label='dropdown-button'
        className='hot-button _border-0 _bg-transparent _outline-0'>
        {label}
        {icon ? (
          <Icon icon={icon} data-test='menu-icon-primary' className='_ml-3 _text-gray-900' />
        ) : null}
      </button>
      {children}
    </hot-dropdown>
  )
}

const CustomDropdownItem = ({
  handleClick,
  children,
  className,
  disabled = false
}: CustomDropdownItemProps) => (
  <button
    slot='menu'
    className={clsx('_p-0 _d-flex _border-0 _outline-0 _m-0 hot-button _w-full', className)}
    onClick={handleClick}
    disabled={disabled}>
    {children}
  </button>
)

CustomDropdown.Item = CustomDropdownItem

export default CustomDropdown
